<style src="./List.scss" lang="scss"></style>

<template src="./List.html"></template>

<script>
	import Teaser from '@/components/Teaser/Teaser';

	/**
	 * Container component to hold other components then displayed as a list.
	 * @vue-prop {Object[]} elements An array of objects representing the inner components of the list
	 * @vue-prop {string} [title] The title of the list
	 * @vue-prop {boolean} [smaller] If the list should present it's content smaller than regular
	 * @vue-prop {boolean} [numbered] If the list should be a numbered list
	 * @vue-prop {'horizontal' | 'vertical'} [orientation] If the list should be horizontal or vertical
	 */
	export default {
		props: {
			elements: Array,
			title: String,
			smaller: {
				type: Boolean,
				default: false
			},
			numbered: {
				validator: function (value) {
					return [true, false].indexOf(value) !== -1;
				}
			},
			orientation: {
				validator: function (value) {
					return ['horizontal', 'vertical'].indexOf(value) !== -1;
				}
			}
		},
		components: {
			'hp-teaser': Teaser
		}
	};
</script>
